module.exports = __webpack_public_path__ + "img/hsctzk.9f3f90dc.jpg";